import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
  // import { Table, Button, Container } from 'react-bootstrap';
  // import { Link } from 'react-router-dom';
import { FaPlus, FaSync, FaBuilding } from 'react-icons/fa';
import { Card, List, Typography, message } from 'antd';
import { fetchMosads } from '../../redux/slices/mosadsSlice';
import { setSelectedMosad, setMosadData, setFirstLoginCompleted } from '../../redux/slices/userSlice';
import { logout } from '../../redux/slices/authSlice';
import { fetchCustomers } from '../../redux/slices/customersSlice';
import { fetchTransactions } from '../../redux/slices/transactionsSlice';
import styles from './Mosads.module.css';
import config from '../../config';
import Navbar1 from '../../components/layout/Navbar';
import { fetchBanks } from '../../redux/slices/banksSlice';
import { useTranslation } from '../../i18n';

const { Title, Text } = Typography;

const Mosads = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const { mosadsList, error } = useSelector((state) => state.mosads);
  const { mosadToken } = useSelector((state) => state.user);
  const selectedMosadCode = useSelector((state) => state.user.selectedMosadCode);

  const currentMosadToken = localStorage.getItem(config.APP_NAME + '_mosadToken');

  if (mosadToken === currentMosadToken && mosadToken !== null) {
    navigate('/dashboard');
  }

  // if (error.message === "Access denied. No token provided." || error.message === "Invalid token. Please log in again") {
  if (error) {
    dispatch(logout());
    document.location.href = '/login';
  }

  useEffect(() => {
    const loadMosads = async () => {
      try {
        if(mosadsList.length === 0) {
          await dispatch(fetchMosads());
        }
        setLoading(false);
      } catch (error) {
        message.error(t('notifications.frontend.common.failedToLoadMosads'));
        setLoading(false);
      }
    };
    loadMosads();
  }, [dispatch]);

  // useEffect(() => {
  //   if (mosadsList?.length === 1 && !selectedMosadCode) {
  //     handleMosadSelect(mosadsList[0]);
  //   }
  // }, [mosadsList, selectedMosadCode]);

  const handleMosadSelect = async (mosad) => {
    try {
      await dispatch(setSelectedMosad(mosad));
      await dispatch(setMosadData(mosad));
      await dispatch(setFirstLoginCompleted(true));
      await dispatch(fetchCustomers());
      await dispatch(fetchTransactions());
      await dispatch(fetchBanks());
      navigate('/dashboard');
    } catch (error) {
      message.error(t('notifications.frontend.common.failedToSelectMosad'));
    }
  };

  const getRoleText = (role) => {
    switch (role) {
      case 'viewer':
        return t('ui.mosads.viewer');
      case 'employee':
        return t('ui.mosads.employee');
      case 'owner':
        return t('ui.mosads.owner');
      case 'admin':
        return t('ui.mosads.admin');
      default:
        return t('ui.mosads.unknown');
    }
  };

  if (loading) {
    return <div className={styles.loading}>{t('ui.mosads.loading')}</div>;
  }

  if (error) {
    return <div className={styles.error}>{error}</div>;
  }

  return (
    <>
      <Navbar1 className={styles.mosadsNavbar} isMosadsScreen={true}/>
      <div className={`${styles.container} ${styles.mosadsContent}`}>
        <Card className={styles.card}>
          <Title level={1} className={styles.subtitle} >{t('ui.mosads.listTitle')}</Title>
            {/* <Text type="secondary" className={styles.subtitle}>
              Choose a mosad to continue
            </Text> */}
            
            <List
              className={styles.list}
              dataSource={mosadsList}
              renderItem={(mosad) => (
                <List.Item
                  className={`${styles.listItem} ${selectedMosadCode === mosad.code ? styles.selected : ''}`}
                  onClick={() => handleMosadSelect(mosad)}
                >
                  <div className={styles.mosadInfo}>
                    {mosad.logo && mosad.logo.trim() !== '' ? (
                      <img 
                        src={mosad.logo} 
                        alt={`${mosad.name} logo`} 
                        className={styles.mosadLogo}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                      />
                    ) : null}
                    <div 
                      className={styles.defaultLogo}
                      style={{ display: mosad.logo && mosad.logo.trim() !== '' ? 'none' : 'flex' }}
                    >
                      <FaBuilding className={styles.defaultIcon} />
                    </div>
                    <div className={styles.mosadNameRole}>
                    <Title level={2}>{mosad.name}</Title>
                    <Text type="secondary">
                      {getRoleText(mosad.role)}
                    </Text>
                    </div>
                  </div>
                  {/* {selectedMosadCode === mosad.code && (
                    <CheckCircleOutlined className={styles.checkIcon} />
                  )} */}
                </List.Item>
              )}
            />
            <div className={styles.actionButtons}>
              <button className={styles.actionButton} onClick={() => navigate('/mosads/new')}>
                <FaPlus className={styles.buttonIcon} />
                <span className={styles.buttonText}>{t('ui.mosads.addNew')}</span>
              </button>
              <button className={styles.actionButton} onClick={() => dispatch(fetchMosads())}>
                <FaSync className={styles.buttonIcon} />
                <span className={styles.buttonText}>{t('ui.mosads.refresh')}</span>
              </button>
            </div>
          </Card>
        </div>
      </>
  );

  // return (
  //   <Container fluid>
  //     <div className={styles.header}>
  //       <h2>מוסדות</h2>
  //       <Button as={Link} to="/mosads/new" variant="primary">
  //         <FaPlus className="me-2" />
  //         מוסד חדש
  //       </Button>
  //     </div>

  //     <Table responsive hover className={styles.table}>
  //       <thead>
  //         <tr>
  //           <th>שם המוסד</th>
  //           <th>כתובת</th>
  //           <th>טלפון</th>
  //           <th>אימייל</th>
  //           <th>פעולות</th>
  //         </tr>
  //       </thead>
  //       <tbody>
  //         {mosads.length === 0 ? (
  //           <tr>
  //             <td colSpan="5" className="text-center">
  //               אין מוסדות להצגה
  //             </td>
  //           </tr>
  //         ) : (
  //           mosads.map(mosad => (
  //             <tr key={mosad.id}>
  //               <td>{mosad.name}</td>
  //               <td>{mosad.address}</td>
  //               <td>{mosad.phone}</td>
  //               <td>{mosad.email}</td>
  //               <td>
  //                 <Button
  //                   as={Link}
  //                   to={`/mosads/${mosad.id}`}
  //                   variant="outline-primary"
  //                   size="sm"
  //                   className="me-2"
  //                 >
  //                   <FaEdit />
  //                 </Button>
  //                 <Button variant="outline-danger" size="sm">
  //                   <FaTrash />
  //                 </Button>
  //               </td>
  //             </tr>
  //           ))
  //         )}
  //       </tbody>
  //     </Table>
  //   </Container>
  // );
};

export default Mosads; 